import { KeyFigureBasicComponent } from './../widgets/key-figure-basic/key-figure-basic.component';
import { Injectable, Type } from '@angular/core';
import { SbPanel, SbWidgetType } from '@models';
import {
    SbAgTableComponent,
    SbFormWidgetComponent,
    SbKeyFigureAdvancedComponent,
    SbLinechartComponent,
    SbMultiSelectComponent,
    SbSelectComponent,
    SbTablePieComponent
} from '../widgets';
import { SbUploadWithPreviewComponent } from '../sb-upload-with-preview/sb-upload-with-preview.component';
import { SbLayoutConfigurationService } from './sb-layout-configuration.service';
import { PriceListComponent } from '../price-and-valuation/components/price-list/price-list.component';
import { SbKeyValueLegacyComponent } from '../widgets/sb-key-value-legacy/sb-key-value-legacy.component';
import { SbCreditsDashboardComponent } from 'src/app/pages/authenticated/credits/pages/dashboard/sb-credits-dashboard.component';
import { SbValueBridgeLegacyComponent } from '../../shared/components/sb-value-bridge-legacy/sb-value-bridge-legacy.component';
import { SbValueBridgeComponent } from '../../pages/authenticated/overview/components/sb-value-bridge/sb-value-bridge.component';

//TODO: May be discussed to be used in a shared place. MK.
interface CacheEntry<T> {
    data: T;
    timestamp: number;
}
@Injectable({
    providedIn: 'root'
})
export class SbPanelService {
    panelTypeToComponent = new Map<SbWidgetType, Type<any>>([
        [SbWidgetType.KeyFigureBasic, KeyFigureBasicComponent],
        [SbWidgetType.LineChart, SbLinechartComponent],
        [SbWidgetType.AgDataTable, SbAgTableComponent],
        [SbWidgetType.KeyFigureAdvanced, SbKeyFigureAdvancedComponent],
        [SbWidgetType.MultiSelect, SbMultiSelectComponent],
        [SbWidgetType.SingleSelect, SbSelectComponent],
        [SbWidgetType.PieChartTable, SbTablePieComponent],
        [SbWidgetType.FormWidget, SbFormWidgetComponent],
        [SbWidgetType.FileUpload, SbUploadWithPreviewComponent],
        [SbWidgetType.PriceWidget, PriceListComponent],
        [SbWidgetType.KeyValueWidget, SbKeyValueLegacyComponent],
        [SbWidgetType.CreditsDashboard, SbCreditsDashboardComponent],
        [SbWidgetType.ValueBridge, SbValueBridgeLegacyComponent], // use the legacy component until new has passed testing
        [SbWidgetType.ValueBridge, SbValueBridgeComponent]
    ]);

    panelMap: Map<string, SbPanel> = new Map<string, SbPanel>();
    panelsLoaded = false;

    private panelCache: CacheEntry<any>;
    private cacheTimeout = 60 * 60 * 1000;

    constructor(private layoutConfigurationService: SbLayoutConfigurationService) {}

    async getAPanel(panelId: string): Promise<SbPanel> {
        if (!this.panelsLoaded) {
            //This is called multiple times because it is being called for each panelId.
            await this.loadPanels();
        }
        return this.panelMap.get(panelId);
    }

    /**
     * Retrieves the  set of details for all panels.
     * This function gets called for each panel on the page,
     * resulting in relatively significant amounts of data being fetched from the API backend multiple times.
     * To mitigate this, we're implementing a caching strategy that keeps the data for an hour.
     * A simple caching strategy is used here as this code will soon be deprecated. MK.
     */
    async loadPanels() {
        const now = Date.now();

        if (!this.panelCache || now - this.panelCache.timestamp > this.cacheTimeout) {
            const panelsPromise = this.layoutConfigurationService
                .getPanels()
                .toPromise()
                .then(
                    (res) => {
                        const panelMap = new Map<string, SbPanel>(
                            res.map((p) => [p.panelId, p] as [string, SbPanel])
                        );
                        this.panelMap = panelMap;
                        this.panelsLoaded = true;
                        return res;
                    },
                    (err) => {
                        console.error('Could not load panels: ' + err);
                        throw err;
                    }
                );

            this.panelCache = {
                data: panelsPromise,
                timestamp: now
            };
        }

        return this.panelCache.data;
    }

    resolveComponent(panelType: SbWidgetType): Type<any> {
        return this.panelTypeToComponent.get(panelType);
    }

    clear() {
        if (this.panelsLoaded) {
            this.panelMap = new Map<string, SbPanel>();
            this.panelsLoaded = false;
        }
    }
}
